<template>
  <div class="channel-edit">
    <el-card>
      <div slot="header">
        <span>{{creatable ? '新增' : '编辑'}}渠道</span>
        <el-button type="text" @click="demo">查看编辑规范</el-button>
      </div>
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item label="渠道名" prop="name">
          <el-input v-model="form.name" placeholder="请输入渠道名"></el-input>
        </el-form-item>
        <el-form-item label="渠道栏目" prop="channel">
          <channel-cascade v-model="form.channel" :props="channelProps" placeholder="请选择渠道栏目"></channel-cascade>
        </el-form-item>
        <el-form-item label="渠道简介" prop="info">
          <el-input
            type="textarea"
            v-model="form.info"
            placeholder="请输入渠道介绍/是否可定向投放/定向区域/人群属性/合作机会点等"
            :rows="4"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="流量规模">
          <el-input v-model="form.scale" placeholder="举例:3000万/DAU、核卡200/月"></el-input>
        </el-form-item>
        <el-form-item label="合作方式">
          <el-select multiple v-model="form.how" placeholder="请选择合作方式">
            <el-option
              v-for="item in ['CPA', 'CPC', 'CPS', 'CPM', 'CPD', 'CPT', '其他']"
              :key="item"
              :value="item"
              :label="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商务价格">
          <el-input v-model="form.price" placeholder="举例:6元/CPA、0.3元起/CPC"></el-input>
        </el-form-item>
        <el-form-item label="合作流量规模">
          <el-input v-model="form.scale2" placeholder="举例:约3万有效名单/月"></el-input>
        </el-form-item>
        <el-form-item label="当前合作状态">
          <el-select v-model="form.status" placeholder="请选择当前合作状态">
            <el-option
              v-for="item in ['待测试', '测试中', '合作中', '暂停中', '淘汰退出']"
              :key="item"
              :value="item"
              :label="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商务负责人">
          <el-input v-model="form.responsor" placeholder="请输入商务负责人"></el-input>
        </el-form-item>
        <el-form-item label="运营负责人">
          <el-input v-model="form.responsor2" placeholder="请输入运营负责人"></el-input>
        </el-form-item>
        <el-form-item label="入口方式">
          <el-input v-model="form.position" placeholder="请输入入口方式"></el-input>
        </el-form-item>
        <el-form-item label="位置图片">
          <el-upload
            multiple
            ref="position"
            action="/changjing/upload"
            list-type="picture-card"
            accept="image/*"
            :data="{type: 'position'}"
            :auto-upload="false"
            :file-list="positions"
            :http-request="httpRequest"
            :on-remove="onRemove"
            :limit="40"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="参考案例">
          <el-upload
            ref="example"
            action="/changjing/upload"
            :auto-upload="false"
            :data="{type: 'example'}"
            :http-request="httpRequest"
            :file-list="examples"
            :limit="1"
            :on-remove="onRemove"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传一份文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="宣传材料">
          <el-upload
            ref="file"
            action="/changjing/upload"
            :data="{type: 'file'}"
            :auto-upload="false"
            :file-list="files"
            :http-request="httpRequest"
            :on-remove="onRemove"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit" :loading="loading">提交</el-button>
          <el-button @click="$router.push('/changjing?active=1')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import http from '@/plugins/axios'
import ChannelCascade from '@/components/service/channel-cascade'
export default {
  components: { ChannelCascade },
  data() {
    return {
      channelProps: {
        multiple: true
      },
      loading: false,
      form: {},
      positions: [],
      examples: [],
      files: [],
      id: '',
      count: 0,
      rules: {
        name: { required: true, message: '请输入渠道名' },
        channel: { required: true, message: '请选择渠道栏目', trigger: 'change' },
        info: { required: true, message: '请输入渠道简介' }
      }
    }
  },
  computed: {
    creatable() { return +this.$route.params.id === 0 }
  },
  beforeRouteEnter(to, from, next) {
    if (+to.params.id === 0) {
      next()
    } else {
      http.post('/changjing/jdetail', {
        id: to.params.id
      }).then(res => {
        next(vm => {
          const params = res.data.data[0]
          vm.positions = params.position_img_id.map(x => {
            return {
              name: x.name,
              url: `/api/changjing/get?i=${x.fileid}`,
              id: x.fileid
            }
          })
          vm.files = params.file.map(x => {
            return {
              name: x.name,
              id: x.fileid
            }
          })
          if (params.example.exampleid) {
            vm.examples = [{
              name: params.example.examplename,
              id: params.example.exampleid
            }]
          }
          // 兼容之前选的
          params.channel = params.taglist && params.taglist.length ? params.taglist.map(x => {
            return [+x.first, +x.second]
          }) : [[+params.first, +params.second]]
          params.how = params.how.length > 0 ? params.how.split('/') : []
          vm.form = params
        })
      })
    }
  },
  methods: {
    demo() {
      window.open('/api/changjing/get?i=1')
    },
    onRemove(file, fileList) {
      if (file.status === 'success') {
        // 下面两行看看需不需要
        this.examples = []
        delete this.form.example
        this.$http.post('/changjing/deletefile', {
          fileid: file.id
        }).then(() => { })
      }
    },
    httpRequest({ action, file, data }) {
      this.count++
      const params = new FormData()
      params.append('file', file)
      params.append('type', data.type)
      params.append('id', this.id)
      this.$http.post(action, params, {
        timeout: 5 * 60 * 1000
      }).then(res => {
        this.count--
        if (this.count === 0) {
          this.loading = false
          this.$router.go(-1)
        }
      })
    },
    getTagList() {
      return this.form.channel.map(_channel => {
        return {
          first: _channel[0],
          second: _channel[1]
        }
      })
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          const params = JSON.parse(JSON.stringify(this.form))
          params.taglist = this.getTagList()
          params.how = params.how.join('/')
          delete params.channel
          this.$http.post(this.creatable && !this.form.id ? '/changjing/jadd' : '/changjing/jchange', params).then(res => {
            if (res.successful) {
              this.id = res.data.id
              this.form.id = res.data.id
              const refs = ['example', 'file', 'position']
              if (refs.every(x => this.$refs[x].uploadFiles.filter(x => x.status !== 'success').length === 0)) {
                this.$router.push('/changjing?active=1')
              } else {
                refs.forEach(x => this.$refs[x].submit())
              }
            }
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
.channel-edit {
  .el-card__header > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  img {
    width: 150px;
    object-fit: cover;
    display: block;
  }
  .el-upload-list--picture-card .el-upload-list__item,
  .el-upload--picture-card {
    width: 120px;
    height: 120px;
  }
  .el-upload--picture-card{
    line-height: 120px;
  }
  .el-textarea,
  .el-input,
  .el-cascader{
        width: 400px;
  }
}
</style>
